import { useMemo } from 'react';
import tw from 'twin.macro';
import { useTranslation } from 'react-i18next';

import { GarmOverviewListItem } from '@insights_module/components/show_details_screen/GarmOverviewListItem';
import { useInsightsContext } from '@insights_module/context/InsightsContext';
import { CategoryType, GarmRiskLevelType } from '@insights_module/types/BrandSafety';
import { Spacer } from '@components/Spacer';
// import { Switch } from '@components/Switch';
import { useShowDetailsContext } from '@insights_module/context/ShowDetailsContext';

import { Sidebar, SidebarItem } from '@insights_module/components/Sidebar';
import { useShowDetailsTableData } from '@insights_module/hooks/useShowDetailsTableData';

const NoResultsOverlay = tw.div`px-3 py-4 flex z-10 bg-gray-3 text-[13px]`;
const OverviewOuterWrapper = tw.div`bg-transparent w-full relative`;
const ListWrapper = tw.div`relative`;
const HeaderContainer = tw.div`w-full flex items-center justify-between`;

const ItemHeader = () => {
  const { t } = useTranslation();
  // const { showLast90Days, setShowLast90Days } = useShowDetailsContext();
  return (
    <HeaderContainer>
      <Sidebar.Title>{t('insights.garm_overview.title')}</Sidebar.Title>
      {/* TODO: check if we need this, because it is removed from the design */}
      {/* <Switch
        id='show-last-90-days'
        name='show-last-90-days'
        label='90-days score'
        onChange={(val) => setShowLast90Days(val)}
        isActive={showLast90Days}
        disabled={false}
        title='90-days Score'
      /> */}
    </HeaderContainer>
  );
};

const GarmOverview = () => {
  const { t } = useTranslation();
  const { setSelectedGarmCategory } = useInsightsContext();
  const {
    setSelectedShowDetailsGarmCategory,
    setSelectedShowDetailsGarmRisk,
    selectedShowDetailsGarmCategory,
  } = useShowDetailsContext();

  const { show, garmOverview, isLoading: isShowLoading } = useShowDetailsTableData();

  const showGarmResults = useMemo(
    () =>
      show?.garm
        ? Object.entries(show?.garm || {}).map(([key, value]) => ({
            category: key as CategoryType,
            risk: value.toLowerCase() as GarmRiskLevelType,
          }))
        : null,
    [show]
  );

  const handleSelectCategory = (category: CategoryType) => {
    const val = selectedShowDetailsGarmCategory === category ? '' : category;

    setSelectedGarmCategory(val);
    setSelectedShowDetailsGarmCategory(val as CategoryType);

    if (!val) return;

    const garmRiskRange = Object.entries(garmOverview?.[val] || {})
      .filter(([key, value]) => {
        if (value > 0) {
          return key;
        }
      })
      .map((item) => item[0]);

    const hasRisk = garmRiskRange.some((item) => item !== 'unrelated');

    const rangeValue = hasRisk
      ? garmRiskRange.filter((item) => item !== 'unrelated')
      : garmRiskRange;

    setSelectedShowDetailsGarmRisk(rangeValue);
  };

  return (
    <SidebarItem isLoading={isShowLoading} header={<ItemHeader />}>
      <OverviewOuterWrapper>
        {!showGarmResults?.length && !isShowLoading ? (
          <NoResultsOverlay>
            {show?.audio_count ? (
              <div>{t('insights.garm_overview.garm_error_result')}</div>
            ) : (
              <div>{t('insights.garm_overview.no_garm_results')}</div>
            )}
          </NoResultsOverlay>
        ) : (
          <>
            <Sidebar.Subtitle>{t('insights.garm_overview.sub_title')}</Sidebar.Subtitle>
            <Spacer direction='vertical' size='md' />
            <ListWrapper>
              {showGarmResults?.map(({ category, risk }) => (
                <GarmOverviewListItem
                  key={category}
                  garm={{ category, risk }}
                  isSelected={selectedShowDetailsGarmCategory === category}
                  onClick={() => handleSelectCategory(category)}
                />
              ))}
            </ListWrapper>
          </>
        )}
      </OverviewOuterWrapper>
    </SidebarItem>
  );
};

export { GarmOverview };
